import { useQuery } from "@tanstack/react-query";

import { axiosInstance } from "@needl-ai/common/lib/axios";
import {
  FILE_UPLOAD_SOURCES,
  type UploadSourceType,
} from "@needl-ai/common/upload/hooks/useInitUploadComplete";

export const useFileUploadConfig = (
  source: UploadSourceType = FILE_UPLOAD_SOURCES.ASK_NEEDL
) => {
  return useQuery({
    queryKey: ["file-upload-config", source],
    queryFn: () =>
      axiosInstance.get<ApiResponse>("/upload", {
        params: {
          source,
        },
      }),
    select: (data): FileUploadConfig => ({
      ...data.data.config,
      file_name_suffixes: [],
      allow_folder_upload: false,
    }),
  });
};

export type FileUploadConfig = BaseUploadConfig & {
  file_name_suffixes: string[];
  allow_folder_upload: boolean;
};

type ApiResponse = {
  config: BaseUploadConfig;
};

type BaseUploadConfig = {
  file_count_limit: number;
  file_size_limit: number;
  file_types: string[];
  mime_types: string[];
};
